export default function reducer(state, action) {
  return state;
}


// WEBPACK FOOTER //
// ./src/reducer.js